import React from 'react';
import _ from 'lodash';
import { defineMessages } from 'react-intl';
import { loadFavoriteCourses } from '../../../actions/auth';
import Layout from '../../../components/Layout/Layout';
import { ssrRequest } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import notAuthorized from '../../not-authorized';
import CourseDetailsNotes from './CourseDetailsNotes';
import notFound from '../../not-found/index';

import {
  getCourseBySlug,
  getCourseTextNotes,
  getCourseVideoNotes,
  // getCoursePublicNotesStatus,
} from '../../../actions/courseDetails';
import { getDiscussions } from '../../../actions/discussions';

const messages = defineMessages({
  coursesTitle: {
    id: 'CourseDetailsNotes.coursesTitle',
    defaultMessage: '{name} - Notes - Course',
    description: 'Title displayed in Course detail notes page',
  },
});

async function action(context) {
  const {
    store,
    params,
    fetch,
    intl: { formatMessage },
  } = context;
  const { courseSlug } = params;

  const { auth } = store.getState();

  if (!isLoggedIn(auth)) {
    return notAuthorized(context);
  }

  await store.dispatch({
    type: getCourseBySlug(courseSlug).types[0],
  });
  const promises = [];

  promises.push(async () => {
    await store.dispatch({
      type: getCourseBySlug(courseSlug).types[0],
    });

    try {
      const res = await getCourseBySlug(courseSlug).promise(fetch);

      const resText = await res.text();

      const json = resText ? JSON.parse(resText) : {};

      if (res.status !== 200) {
        if ([403, 404].includes(res.status)) {
          return notFound(context);
        }

        return store.dispatch({
          error: json,
          type: getCourseBySlug(courseSlug).types[2],
        });
      }

      const result = {
        status: res.status,
        json,
      };

      return store.dispatch({
        result,
        type: getCourseBySlug(courseSlug).types[1],
      });
    } catch (error) {
      const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
      middlewareError.stack = error?.stack;
      console.error(middlewareError);
      return store.dispatch({
        error,
        type: getCourseBySlug(courseSlug).types[2],
      });
    }
  });

  promises.push(async () => {
    await store.dispatch({
      type: getCourseTextNotes(courseSlug).types[0],
    });

    try {
      const res = await getCourseTextNotes(courseSlug).promise(fetch);

      const resText = await res.text();

      const json = resText ? JSON.parse(resText) : {};

      if (res.status !== 200) {
        if ([403, 404].includes(res.status)) {
          return notFound(context);
        }

        return store.dispatch({
          error: json,
          type: getCourseTextNotes(courseSlug).types[2],
        });
      }

      const result = {
        status: res.status,
        json,
      };

      return store.dispatch({
        result,
        type: getCourseTextNotes(courseSlug).types[1],
      });
    } catch (error) {
      const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
      middlewareError.stack = error?.stack;
      console.error(middlewareError);
      return store.dispatch({
        error,
        type: getCourseTextNotes(courseSlug).types[2],
      });
    }
  });

  promises.push(async () => {
    await store.dispatch({
      type: getCourseVideoNotes(courseSlug).types[0],
    });

    try {
      const res = await getCourseVideoNotes(courseSlug).promise(fetch);

      const resText = await res.text();

      const json = resText ? JSON.parse(resText) : {};

      if (res.status !== 200) {
        if ([403, 404].includes(res.status)) {
          return notFound(context);
        }

        return store.dispatch({
          error: json,
          type: getCourseVideoNotes(courseSlug).types[2],
        });
      }

      const result = {
        status: res.status,
        json,
      };

      return store.dispatch({
        result,
        type: getCourseVideoNotes(courseSlug).types[1],
      });
    } catch (error) {
      const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
      middlewareError.stack = error?.stack;
      console.error(middlewareError);
      return store.dispatch({
        error,
        type: getCourseVideoNotes(courseSlug).types[2],
      });
    }
  });

  promises.push(async () => {
    const query = {
      page: 1,
      sort: '-createDate',
      search: '',
      perPage: 50,
      courseId: courseSlug,
    };

    return ssrRequest({
      getAction: getDiscussions.bind(this, query),
      fetch,
      store,
    });
  });

  // promises.push(async () => {
  //   await store.dispatch({
  //     type: getCoursePublicNotesStatus(courseId).types[0],
  //   });
  //
  //   try {
  //     const res = await getCoursePublicNotesStatus(courseId).promise(fetch);
  //
  //     const resText = await res.text();
  //
  //     const json = resText ? JSON.parse(resText) : {};
  //
  //     if (res.status !== 200) {
  //       if ([403, 404].includes(res.status)) {
  //         return notFound(context);
  //       }
  //
  //       return store.dispatch({
  //         error: json,
  //         type: getCoursePublicNotesStatus(courseId).types[2],
  //       });
  //     }
  //
  //     const result = {
  //       status: res.status,
  //       json,
  //     };
  //
  //     return store.dispatch({
  //       result,
  //       type: getCoursePublicNotesStatus(courseId).types[1],
  //     });
  //   } catch (error) {
  //     console.error('MIDDLEWARE ERROR:', error);
  //     return store.dispatch({
  //       error,
  //       type: getCoursePublicNotesStatus(courseId).types[2],
  //     });
  //   }
  // });

  promises.push(async () => store.dispatch(loadFavoriteCourses(fetch)));

  const requests = await Promise.all(promises.map(promise => promise()));
  const notFoundReq = _.find(requests, item => _.get(item, 'status') === 404);

  if (notFoundReq) {
    return notFoundReq;
  }

  const { courseDetails } = store.getState();

  const title = formatMessage(messages.coursesTitle, {
    name: _.get(courseDetails, 'course.name', ''),
  });

  return {
    chunks: ['course-notes'],
    title,
    component: (
      <Layout context={context}>
        <CourseDetailsNotes data={{}} title={title} />
      </Layout>
    ),
  };
}

export default action;
